module.exports = __webpack_public_path__ + "img/main.dac59b04.jpg";